export default __webpack_public_path__ + "static/media/sb-ICO-02.50c94277.webp";